import { numberValidator, ipValidator } from '../../../common/utils/validator';
import { formElement as formEl } from '../summary/summary.constant';
import { getOptions } from './plan.service';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { VPN_CONFIG } from 'common/constants/app.constants';
import { MODULE_ID } from 'home/common/constants/constants';

const formElement = { ...formEl, options: [], commercial: false, formKey: '' };

export const formSchema = {
  lastMile: { ...formElement },
  pop: { ...formElement },
  cloud: { ...formElement },
  ipVersion: { ...formElement },
  routingProtocol: { ...formElement },
  qos: { ...formElement },
  business: { ...formElement, validator: numberValidator },
  prt: { ...formElement, validator: numberValidator },
  pnrt: { ...formElement, validator: numberValidator },
  standard: { ...formElement, validator: numberValidator },
  vpnType: { ...formElement },
  vpnTopology: { ...formElement },
  linkTopology: { ...formElement },
  redundancy: { ...formElement },
  manageability: { ...formElement },
  portBandwidth: { ...formElement },
  accessBandwidth: { ...formElement },
  cpeType: { ...formElement }
};

const getFormSchema = (formType) => {
  const getLanWanIps = () => {
    if (formType === 'PRIMARY') {
      return {
        lanIp: { ...formElement, validator: ipValidator },
        wanIp: { ...formElement, validator: ipValidator }
      };
    }

    return {
      lanIp_secondary: { ...formElement, validator: ipValidator },
      wanIp_secondary: { ...formElement, validator: ipValidator }
    };
  };

  return {
    lastMile: { ...formElement },
    pop: { ...formElement },
    cloud: { ...formElement },
    ipVersion: { ...formElement },
    routingProtocol: { ...formElement },
    qos: { ...formElement },
    business: { ...formElement, validator: numberValidator },
    prt: { ...formElement, validator: numberValidator },
    pnrt: { ...formElement, validator: numberValidator },
    standard: { ...formElement, validator: numberValidator },
    vpnType: { ...formElement },
    vpnTopology: { ...formElement },
    linkTopology: { ...formElement },
    redundancy: { ...formElement },
    manageability: { ...formElement },
    portBandwidth: { ...formElement },
    accessBandwidth: { ...formElement },
    cpeType: { ...formElement },
    ...getLanWanIps()
  };
};

const getManagabilityValue = (selectedPlan, keyName, formType, leadStatus) => {
  if (leadStatus && selectedPlan && selectedPlan.specs && selectedPlan.specs.length) {
    const spec = selectedPlan.specs.find((spec) => spec.name === keyName && spec.linkType === formType);
    // console.log('manage spec', spec);
    if (spec && spec.value) {
      const opt = SERVICE_OPTIONS && SERVICE_OPTIONS.length && SERVICE_OPTIONS.find((option) => option.id === spec.value);
      // console.log('manageopt 2', opt);
      return opt;
    }
    // return SERVICE_OPTIONS[0];
  } else {
    if (formType === 'PRIMARY') {
      const opt = SERVICE_OPTIONS && SERVICE_OPTIONS.length && SERVICE_OPTIONS.find((option) => option.id === selectedPlan.service);
      // console.log('PRIMARY manageopt', opt);
      return opt;
    }
  }
  return SERVICE_OPTIONS[0];
};

const getValueFromLead = (selectedPlan, keyName, formType, defaltValue) => {
  if (selectedPlan && selectedPlan.specs && selectedPlan.specs.length) {
    const spec = selectedPlan.specs.find((spec) => spec.name === keyName && spec.linkType === formType);
    return spec ? spec.value : defaltValue;
  }
};

const getPortBandwidthFromLead = (selectedPlan, keyName, formType, options) => {
  if (selectedPlan && selectedPlan.specs && selectedPlan.specs.length) {
    const spec = selectedPlan.specs.find((spec) => spec.name === keyName && spec.linkType === formType);
    // console.log('spec', spec);
    if (spec && spec.value) {
      const opt = options && options.length && options.find((option) => option.key === spec.value);
      // console.log('opt', opt);
      return opt;
    }
    return options[options.length - 1];
  }
};

const setOptionsForCommercialAttribute = (keyName, { values, defaultValue, commercial } = {}, selectedPlan = null, leadStatus = false, formType, formData, customerData = null) => {
  const options = getOptions(values, { formKey: keyName, commercial });
  if (leadStatus) {
    defaultValue = getValueFromLead(selectedPlan, keyName, formType, defaultValue);
    // console.log('defaultValue from Lead', defaultValue)
  }
  formData[keyName].options = options;
  formData[keyName]['originalOptions'] = options;
  formData[keyName].value = options.filter((option) => option.key === defaultValue)[0];
  formData[keyName].commercial = commercial;
  formData[keyName].formKey = keyName;
  if (keyName === 'portBandwidth') {
    formData[keyName].value = leadStatus ? getPortBandwidthFromLead(selectedPlan, keyName, formType, options) : options[options.length - 1];
  }

  // if(keyName === 'vpnType'){
  //     console.log('vpnType options', formType, options)
  //     console.log('vpnType defaultValue', formType, defaultValue)
  // }
  // if(keyName === 'vpnTopology'){
  //     console.log('vpnTopology options', formType, options)
  //     console.log('vpnTopology defaultValue', formType, defaultValue)
  // }
  if (keyName === 'linkTopology') {
    if (formData['vpnTopology'] && formData['vpnTopology'].value) {
      const optionsForLink = getOptionsForLink(formData['vpnTopology'].value, options);
      // console.log('linkTopology optionsForLink', formType, optionsForLink)
      // console.log('linkTopology defaultValue', formType, defaultValue)
      formData[keyName].options = optionsForLink;
      formData[keyName]['originalOptions'] = options;
      formData[keyName].value = optionsForLink.filter((option) => option.key === defaultValue)[0];
    }
  }

  if (keyName === 'lastMile' && customerData) {
    formData[keyName].value = options.find((option) => option.key === customerData?.lastMile);
  }

  if (keyName === 'redundancy' && customerData) {
    formData[keyName].value = options.find((option) => option.key === (customerData?.lastMile === 'Dual LM' ? 'Yes' : 'No'));
  }

  return formData;
};

export const setFormFieldsForInput = (keyName, value, selectedPlan, leadStatus, formType, formData) => {
  if (leadStatus) {
    value = getValueFromLead(selectedPlan, keyName, formType, value);
  }
  formData[keyName].options = [];
  formData[keyName].value = value || '';
  formData[keyName].commercial = false;
  formData[keyName].formKey = keyName;
  return formData;
};

export const setCPE_Specifications = (cpeSpecification, selectedCPE) => {
  const options = getOptions(cpeSpecification[selectedCPE]);
  formSchema.cpeSpecification.options = options;
  formSchema.cpeSpecification.value = options[0];
  return formSchema;
};

export const getDefaultValue = (commercialAttribute, bandwidths, selectedPlan, leadStatus, formType = '', customerData = null) => {
  // console.log('selectedPlan', selectedPlan)
  // console.log('leadStatus', leadStatus)

  const formData = getFormSchema(formType);
  // const formData = {...formSchema};

  if (formType === 'PRIMARY') {
    setOptionsForCommercialAttribute('lastMile', commercialAttribute.configAttributesMap.lastMile, selectedPlan, leadStatus, formType, formData, customerData);
  }
  setOptionsForCommercialAttribute('pop', commercialAttribute.configAttributesMap.pop, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('cloud', commercialAttribute.configAttributesMap.cloud, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('cpeType', commercialAttribute.configAttributesMap.cpeType, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('ipVersion', commercialAttribute.configAttributesMap.ipVersion, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('routingProtocol', commercialAttribute.configAttributesMap.routingProtocol, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('qos', commercialAttribute.configAttributesMap.qos, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('business', commercialAttribute.configAttributesMap.business, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('prt', commercialAttribute.configAttributesMap.prt, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('vpnType', commercialAttribute.configAttributesMap.vpnType, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('vpnTopology', commercialAttribute.configAttributesMap.vpnTopology, selectedPlan, leadStatus, formType, formData);
  setOptionsForCommercialAttribute('linkTopology', commercialAttribute.configAttributesMap.linkTopology, selectedPlan, leadStatus, formType, formData);
  if (formType === 'PRIMARY') {
    setOptionsForCommercialAttribute('redundancy', commercialAttribute.configAttributesMap.redundancy, selectedPlan, leadStatus, formType, formData, customerData);
  }

  setOptionsForCommercialAttribute('portBandwidth', prepareOptionsForBandwidth(bandwidths, selectedPlan.speed), selectedPlan, leadStatus, formType, formData);

  formData['manageability'].options = SERVICE_OPTIONS;
  // formData['manageability'].value =  leadStatus ? getManagabilityFromLead(selectedPlan, 'manageability', formType) : SERVICE_OPTIONS[0];
  formData['manageability'].value = getManagabilityValue(selectedPlan, 'manageability', formType, leadStatus);
  formData['manageability'].formKey = 'manageability';

  if (formData['manageability']?.value?.id !== 'UNMANAGED') {
    formData['routingProtocol'].options = formData['routingProtocol']?.options?.filter((item) => item.id !== 'None');
  }

  setFormFieldsForInput('pnrt', null, selectedPlan, leadStatus, formType, formData);
  setFormFieldsForInput('prt', null, selectedPlan, leadStatus, formType, formData);
  setFormFieldsForInput('standard', null, selectedPlan, leadStatus, formType, formData);
  setFormFieldsForInput('business', null, selectedPlan, leadStatus, formType, formData);
  setFormFieldsForInput('accessBandwidth', formData.portBandwidth.options[formData.portBandwidth.options.length - 1].key, selectedPlan, leadStatus, formType, formData);

  // Set lanIp/ wanIp/lanIp_secondary/wanIp_secondary from Session Storage

  const savedLanIP = getFromSessionStorage(MODULE_ID, formType === 'PRIMARY' ? VPN_CONFIG.PRIMARY_LAN_IP : VPN_CONFIG.SECONDARY_LAN_IP);
  const savedWanIP = getFromSessionStorage(MODULE_ID, formType === 'PRIMARY' ? VPN_CONFIG.PRIMARY_WAN_IP : VPN_CONFIG.SECONDARY_WAN_IP);

  setFormFieldsForInput(formType === 'PRIMARY' ? 'lanIp' : 'lanIp_secondary', savedLanIP, null, null, null, formData);
  setFormFieldsForInput(formType === 'PRIMARY' ? 'wanIp' : 'wanIp_secondary', savedWanIP, null, null, null, formData);

  const qosState = leadStatus ? getQosValuesFromLead(selectedPlan, 'qos', formType, formData) : getQOSState(formData, formData.qos.value);
  // console.log('formData', formType, formData)
  return { ...formData, ...qosState };
};

const getQosValuesFromLead = (selectedPlan, keyName, formType, form) => {
  const qos = getValueFromLead(selectedPlan, keyName, formType, form.qos && form.qos.value && form.qos.value.key);
  const portBw = (form.portBandwidth && form.portBandwidth.value && form.portBandwidth.value.key && form.portBandwidth.value.key) || 0;
  const business = getValueFromLead(selectedPlan, 'business', formType, `${portBw.toString().replace(' Mbps', '')}`);
  if (qos === 'Multiple') {
    const pnrt = getValueFromLead(selectedPlan, 'pnrt', formType, '');
    const prt = getValueFromLead(selectedPlan, 'prt', formType, '');
    const standard = getValueFromLead(selectedPlan, 'standard', formType, '');
    return {
      ...form,
      pnrt: { ...form.pnrt, value: pnrt, validator: numberValidator },
      prt: { ...form.prt, value: prt, validator: numberValidator },
      standard: {
        ...form.standard,
        value: standard,
        validator: numberValidator
      },
      business: {
        ...form.business,
        value: business,
        validator: numberValidator
      },
      qos: { ...form['qos'], value: form.qos.value }
    };
  }
  return {
    ...form,
    pnrt: { ...form.pnrt, value: '0', disabled: true },
    prt: { ...form.prt, value: '0', disabled: true },
    standard: { ...form.standard, value: '0', disabled: true },
    business: { ...form.business, value: business, disabled: true },
    qos: { ...form['qos'], value: form.qos.value }
  };
};

export const getQOSState = (form, selectedOption) => {
  const value = (form.portBandwidth && form.portBandwidth.value && form.portBandwidth.value.key) || 0;
  if (selectedOption && selectedOption.key === 'Multiple') {
    return {
      ...form,
      pnrt: { ...formElement.pnrt, value: '', validator: numberValidator },
      prt: { ...formElement.prt, value: '', validator: numberValidator },
      standard: {
        ...formElement.standard,
        value: '',
        validator: numberValidator
      },
      business: {
        ...formElement.business,
        value: '',
        validator: numberValidator
      },
      [selectedOption && selectedOption.formKey]: {
        ...form[selectedOption && selectedOption.formKey],
        value: selectedOption
      }
    };
  }
  return {
    ...form,
    pnrt: { ...formElement.pnrt, value: '0', disabled: true },
    prt: { ...formElement.prt, value: '0', disabled: true },
    standard: { ...formElement.standard, value: '0', disabled: true },
    business: {
      ...formElement.business,
      value: `${value.toString().replace(' Mbps', '')}`,
      disabled: true
    },
    [selectedOption && selectedOption.formKey]: {
      ...form[selectedOption && selectedOption.formKey],
      value: selectedOption
    }
  };
};

export const SERVICE_OPTIONS = [
  {
    id: 'MANAGED',
    displayName: 'Managed Services',
    value: 'MANAGED',
    formKey: 'manageability'
  },
  {
    id: 'UNMANAGED',
    displayName: 'Unmanaged Services',
    value: 'UNMANAGED',
    formKey: 'manageability'
  },
  {
    id: 'PARTIALLY_MANAGED',
    displayName: 'Partially Managed',
    value: 'PARTIALLY_MANAGED',
    formKey: 'manageability'
  }
];

export const prepareOptionsForBandwidth = (list, selectedPlanSpeed) => {
  if (Array.isArray(list)) {
    const data = list.filter(({ speed }) => parseInt(speed) <= parseInt(selectedPlanSpeed)).map(({ speed }) => speed);
    let findIndex = data && data.length > 0 && data.findIndex((item) => item === selectedPlanSpeed);
    if (findIndex === -1 || !findIndex) {
      findIndex = 0;
    }
    return { values: data, defaultValue: data[findIndex] };
  }
  return [];
};

const getOptionsForLink = (selected, options) => {
  const vpnTopology = selected.displayName.split('&');
  return options.filter(({ displayName }) => {
    return vpnTopology.length > 1 ? displayName.includes(vpnTopology[0].trim()) || displayName.includes(vpnTopology[1].trim()) : displayName.includes(vpnTopology[0].trim());
  });
};

export const validationKeysForQOS = ['prt', 'pnrt', 'standard', 'business'];

export const FORM_FIELDS = {
  ROUTING_PROTOCOL: 'routingProtocol'
};
